module.exports = __webpack_public_path__ + "img/open-vip.d420fe71.png";